import "../../utils/tailwind.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { PageProvider, useFreeTrialProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Button from "../../components/Buttons";
import Switch from "../../components/switch";
import TableLoader from "../../components/table-loader";
import { FormikInput } from "../../components/input";
import { FormikDropdown } from "../../components/dropdown";

const validationSchema = Yup.object({
  days: Yup.number()
    .typeError("Enter a number of days")
    .integer("Enter a whole number of days")
    .min(1, "Must be at least 1 day")
    .max(365, "Must be 365 days or fewer")
    .required("Enter a number of days"),
});

export default function FreeTrial() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, planOptions, handleSubmit, getFreeTrialQuery, updateFreeTrialQuery } = useFreeTrialProvider();

  if (getFreeTrialQuery?.isPending) {
    return <TableLoader />;
  }

  return (
    <Section>
      <Label className="my-4 text-black text-[16px] font-semibold" label="Coach Free Trial" />
      <Label
        className="mb-4 text-[14px]"
        label="New coaches get this trial once, when they finish signing up. Changes apply to new signups only; trials already running keep their end date."
      />
      <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form className="max-w-[420px]">
            <div className="flex items-center space-x-4 mb-4">
              <Label label="Free trial active" className="mb-0 text-black text-[15px] font-semibold" />
              <Switch checked={values.enabled} onChange={(val) => setFieldValue("enabled", val)} />
            </div>
            <div className="flex flex-col mb-4">
              <Label label="Trial length (days)" className="mb-2 text-black text-[15px] font-semibold" />
              <FormikInput type="number" name="days" rootClassName="w-full" min={1} max={365} />
            </div>
            <div className="flex flex-col mb-4">
              <Label label="Plan during the trial" className="mb-2 text-black text-[15px] font-semibold" />
              <FormikDropdown name="plan_id" options={planOptions} />
            </div>
            <Button type="submit" isLoading={updateFreeTrialQuery?.isPending} className="!bg-[#7C13CA] text-white">
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
